import { flattenErrorTypeArray } from '@equifinance/shared';
import { SectionTitleIcon } from '../../Icons/SectionTitleIcon';
import { PaddedSection } from '../../components/Section';
import General from './General';
import Fees from './Fees';
import { useAccountContext } from '../../../../contexts';

export const LoanDetailsRefName = 'loan-detail';

export default function LoanDetails() {
  const { account } = useAccountContext();
  const { loanDetails, errors, warnings } = account;
  const { fees } = loanDetails ?? {};
  const {
    BrokerFee, ValuationFee, AdviceFee,
  } = fees ?? {};

  const allErrors = [
    ...(errors?.[loanDetails?.id] ?? []),
    ...(errors?.[BrokerFee?.id] ?? []),
    ...(errors?.[ValuationFee?.id] ?? []),
    ...(errors?.[AdviceFee?.id] ?? []),
  ];

  return (
    <PaddedSection
      refName={LoanDetailsRefName}
      title="Loan Details"
      titleIcon={<SectionTitleIcon errors={flattenErrorTypeArray(allErrors)} />}
    >
      <>
        <General loanDetails={loanDetails} errors={errors} warnings={warnings} />
        <Fees loanDetails={loanDetails} />
      </>
    </PaddedSection>
  );
}
